module.exports = __webpack_public_path__ + "static/media/logo.d130739c.svg";